import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {RegisterComponent} from './register/register.component';
import {RegistrationService} from './services/registration.service';
import {RegisterRoeidComponent} from './register-roeid/register-roeid.component';


const routes: Routes = [
  {
    path: 'inregistrare',
    component: RegisterComponent,
  },
  {
    path: 'inregistrare-roeid',
    component: RegisterRoeidComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  providers: [RegistrationService],
  exports: [RouterModule]
})
export class OnboardingRoutingModule {
}
